import { Flex } from '@chakra-ui/layout';
import { Spinner } from '@chakra-ui/spinner';
import { motion } from 'framer-motion';
import React from 'react';
import { PageContainer } from '../../../components/container/PageContainer';

const AnimatedSpinner = motion(Spinner);
interface LoadingPageProps {
  isHeader?: boolean;
}

export const LoadingPage: React.FC<LoadingPageProps> = ({
  isHeader,
  children,
}) => (
  <PageContainer center isHeader={isHeader}>
    <Flex w="full" align="center" direction="column">
      <AnimatedSpinner
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        size="lg"
      />
      {children && children}
    </Flex>
  </PageContainer>
);
